export const defaultItems = [
  {
    id: 0,
    name: 'Интернет-магазин',
    type: 'delivery',
    delivery: 'завтра, 6:00-15:00'
  },
  {
    id: 1,
    name: 'Белая Дача',
    type: 'shop',
    delivery: 'Забрать сейчас'
  }
];

export const expressPointsNames = ['pickup', 'shop'];
